"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftType = void 0;
exports.instanceOfShiftType = instanceOfShiftType;
exports.ShiftTypeFromJSON = ShiftTypeFromJSON;
exports.ShiftTypeFromJSONTyped = ShiftTypeFromJSONTyped;
exports.ShiftTypeToJSON = ShiftTypeToJSON;
exports.ShiftTypeToJSONTyped = ShiftTypeToJSONTyped;
/**
 *
 * @export
 */
exports.ShiftType = {
    Clinical: 'CLINICAL',
    Orientation: 'ORIENTATION',
    OnCall: 'ON_CALL'
};
function instanceOfShiftType(value) {
    for (const key in exports.ShiftType) {
        if (Object.prototype.hasOwnProperty.call(exports.ShiftType, key)) {
            if (exports.ShiftType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function ShiftTypeFromJSON(json) {
    return ShiftTypeFromJSONTyped(json, false);
}
function ShiftTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ShiftTypeToJSON(value) {
    return value;
}
function ShiftTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=ShiftType.js.map